import React, { useState } from 'react';
import { X, MapPin, Tag, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';
import { CTAStrip } from '../components/CTAStrip';
type PortfolioCategory = 'all' | 'before-after' | 'office' | 'house' | 'garden' | 'overseas';
const portfolioItems = [{
  id: 1,
  category: 'before-after',
  title: 'Full House Clearance',
  location: 'Chingford',
  service: 'House Clearance',
  img: 'https://images.unsplash.com/photo-1558618047-3c8c76ca7d13?w=600&auto=format&fit=crop',
  desc: 'Complete 4-bedroom house clearance completed in one day. 90% of items recycled or donated.'
}, {
  id: 2,
  category: 'office',
  title: 'Office Strip-Out',
  location: 'Islington',
  service: 'Office Removals',
  img: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&auto=format&fit=crop',
  desc: 'Full office clearance for a 50-person tech company relocating to new premises.'
}, {
  id: 3,
  category: 'house',
  title: 'Family Home Move',
  location: 'Finchley',
  service: 'House Moves',
  img: 'https://images.unsplash.com/photo-1486325212027-8081e485255e?w=600&auto=format&fit=crop',
  desc: 'Smooth 3-bedroom family home move completed in under 8 hours.'
}, {
  id: 4,
  category: 'garden',
  title: 'Garden Clearance',
  location: 'Wembley',
  service: 'Garden Waste',
  img: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&auto=format&fit=crop',
  desc: 'Large overgrown garden cleared and all green waste composted.'
}, {
  id: 5,
  category: 'overseas',
  title: 'Migration Move to Australia',
  location: 'Chingford → Sydney',
  service: 'Overseas Removals',
  img: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=600&auto=format&fit=crop',
  desc: 'Full container packing and shipping coordination for family emigrating to Australia.'
}, {
  id: 6,
  category: 'before-after',
  title: 'Estate Clearance',
  location: 'Camden',
  service: 'House Clearance',
  img: 'https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=600&auto=format&fit=crop',
  desc: 'Sensitive estate clearance handled with care and full documentation.'
}, {
  id: 7,
  category: 'office',
  title: 'Commercial Office Move',
  location: 'Hackney',
  service: 'Office Removals',
  img: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&auto=format&fit=crop',
  desc: 'Weekend office relocation for a 20-person marketing agency.'
}, {
  id: 8,
  category: 'house',
  title: 'Student Flat Clearance',
  location: 'Hendon',
  service: 'House Clearance',
  img: 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=600&auto=format&fit=crop',
  desc: 'End-of-tenancy clearance for a 5-bedroom student property.'
}, {
  id: 9,
  category: 'garden',
  title: 'Commercial Grounds Clearance',
  location: 'Harrow',
  service: 'Garden Waste',
  img: 'https://images.unsplash.com/photo-1416879595882-3373a0480b5b?w=600&auto=format&fit=crop&q=80&sat=-100',
  desc: 'Large commercial grounds clearance for a property management company.'
}, {
  id: 10,
  category: 'before-after',
  title: 'Hoarder Property Clear',
  location: 'Enfield',
  service: 'House Clearance',
  img: 'https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600&auto=format&fit=crop',
  desc: 'Compassionate and professional clearance of a heavily cluttered property.'
}, {
  id: 11,
  category: 'overseas',
  title: 'Relocation to Canada',
  location: 'Chingford → Toronto',
  service: 'Overseas Removals',
  img: 'https://images.unsplash.com/photo-1578575437130-527eed3abbec?w=600&auto=format&fit=crop&q=80&sat=-50',
  desc: 'Packing crates, customs documentation, and full door-to-door service.'
}, {
  id: 12,
  category: 'office',
  title: 'Shopfitter Waste Removal',
  location: 'Camden',
  service: 'Commercial Waste',
  img: 'https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=600&auto=format&fit=crop&q=80&sat=-30',
  desc: 'Retail fit-out waste cleared overnight to meet opening deadline.'
}];
const filterTabs: {
  key: PortfolioCategory;
  label: string;
}[] = [{
  key: 'all',
  label: 'All Work'
}, {
  key: 'before-after',
  label: 'Before & After'
}, {
  key: 'office',
  label: 'Office Removals'
}, {
  key: 'house',
  label: 'House Moves'
}, {
  key: 'garden',
  label: 'Garden Waste'
}, {
  key: 'overseas',
  label: 'Overseas'
}];
export function PortfolioPage() {
  const [activeFilter, setActiveFilter] = useState<PortfolioCategory>('all');
  const [lightboxItem, setLightboxItem] = useState<(typeof portfolioItems)[0] | null>(null);
  const filtered = activeFilter === 'all' ? portfolioItems : portfolioItems.filter(i => i.category === activeFilter);
  return <div className="pt-16 lg:pt-20" data-id="element-722">
      {/* Hero */}
      <section className="py-16 px-4" style={{
      background: 'linear-gradient(135deg, #1B8F4B 0%, #0F5D2E 100%)'
    }} data-id="element-723">
        <div className="max-w-7xl mx-auto text-center" data-id="element-724">
          <p className="text-green-300 text-sm font-bold uppercase tracking-widest mb-3" data-id="element-725">
            Our Work
          </p>
          <h1 className="text-4xl md:text-5xl font-extrabold text-white mb-4" style={{
          fontFamily: 'Montserrat, sans-serif'
        }} data-id="element-726">
            Portfolio & Gallery
          </h1>
          <p className="text-green-100 text-lg max-w-2xl mx-auto" data-id="element-727">
            Real jobs, real results. Browse our completed projects across London
            and beyond.
          </p>
        </div>
      </section>

      {/* Filters */}
      <section className="sticky top-16 lg:top-20 z-30 bg-white border-b border-gray-200 shadow-sm" data-id="element-728">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-729">
          <div className="flex gap-2 overflow-x-auto py-3" data-id="element-730">
            {filterTabs.map(({
            key,
            label
          }) => <button key={key} onClick={() => setActiveFilter(key)} className="px-5 py-2 rounded-lg text-sm font-semibold whitespace-nowrap transition-all duration-200" style={{
            backgroundColor: activeFilter === key ? '#1B8F4B' : 'transparent',
            color: activeFilter === key ? '#fff' : '#6B7280'
          }} data-id="element-731">
                {label}
              </button>)}
          </div>
        </div>
      </section>

      {/* Gallery Grid */}
      <section className="py-16 px-4 bg-gray-50" data-id="element-732">
        <div className="max-w-7xl mx-auto" data-id="element-733">
          <div className="columns-1 sm:columns-2 lg:columns-3 gap-5 space-y-5" data-id="element-734">
            {filtered.map(item => <div key={item.id} className="break-inside-avoid group relative rounded-2xl overflow-hidden cursor-pointer shadow-sm hover:shadow-xl transition-all duration-300" onClick={() => setLightboxItem(item)} data-id="element-735">
                <img src={item.img} alt={item.title} className="w-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-736" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-5" data-id="element-737">
                  <span className="inline-block px-2 py-1 rounded-full text-xs font-bold text-white mb-2" style={{
                backgroundColor: '#1B8F4B'
              }} data-id="element-738">
                    {item.service}
                  </span>
                  <h3 className="text-white font-bold" style={{
                fontFamily: 'Montserrat, sans-serif'
              }} data-id="element-739">
                    {item.title}
                  </h3>
                  <div className="flex items-center gap-1 text-green-200 text-xs mt-1" data-id="element-740">
                    <MapPin className="w-3 h-3" data-id="element-741" /> {item.location}
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxItem && <div className="fixed inset-0 z-50 bg-black/80 flex items-center justify-center p-4" onClick={() => setLightboxItem(null)} data-id="element-742">
          <div className="bg-white rounded-2xl overflow-hidden max-w-2xl w-full shadow-2xl" onClick={e => e.stopPropagation()} data-id="element-743">
            <div className="relative" data-id="element-744">
              <img src={lightboxItem.img} alt={lightboxItem.title} className="w-full h-64 object-cover" data-id="element-745" />
              <button onClick={() => setLightboxItem(null)} className="absolute top-4 right-4 w-8 h-8 rounded-full bg-black/50 text-white flex items-center justify-center hover:bg-black/70 transition-colors" data-id="element-746">
                <X className="w-4 h-4" data-id="element-747" />
              </button>
            </div>
            <div className="p-6" data-id="element-748">
              <div className="flex items-center gap-3 mb-3" data-id="element-749">
                <span className="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-bold text-white" style={{
              backgroundColor: '#1B8F4B'
            }} data-id="element-750">
                  <Tag className="w-3 h-3" data-id="element-751" /> {lightboxItem.service}
                </span>
                <span className="inline-flex items-center gap-1 text-sm text-gray-500" data-id="element-752">
                  <MapPin className="w-3 h-3" data-id="element-753" /> {lightboxItem.location}
                </span>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2" style={{
            fontFamily: 'Montserrat, sans-serif'
          }} data-id="element-754">
                {lightboxItem.title}
              </h3>
              <p className="text-gray-600 text-sm mb-5" data-id="element-755">{lightboxItem.desc}</p>
              <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 rounded-xl font-bold text-white transition-colors hover:opacity-90" style={{
            backgroundColor: '#1B8F4B',
            fontFamily: 'Montserrat, sans-serif'
          }} onClick={() => setLightboxItem(null)} data-id="element-756">
                Get a Similar Quote <ArrowRight className="w-4 h-4" data-id="element-757" />
              </Link>
            </div>
          </div>
        </div>}

      <CTAStrip data-id="element-758" />
    </div>;
}